<template>
  <div class="product-image" :class="{ border, list }">
    <div v-if="src">
      <div v-if="isString">
        <div v-if="aspectRatio" class="image-container" :style="`padding-top: ${aspectRatio * 100}%`" />
        <img class="fill" v-lazy="src" />
      </div>

      <div v-else-if="isArray">
        <v-carousel height="auto" hide-delimiter-background show-arrows-on-hover>
          <div v-for="(img, i) in src" :key="i">
            <v-carousel-item v-if="img.image_url" :src="img.image_url" />
          </div>
        </v-carousel>
      </div>

      <div v-else-if="isObject">
        <div v-if="aspectRatio" class="image-container" :style="`padding-top: ${aspectRatio * 100}%`" />
        <img class="fill" v-lazy="src.image_url" />
      </div>
    </div>
    <div v-else class="image-default" :style="`padding-top: ${aspectRatio * 100}%`">
      <v-icon class="fill">mdi-flower</v-icon>
    </div>
    <div v-if="not_in_stock" class="request-only">{{ $t('request_only') }}</div>
  </div>
</template>

<script>
export default {
  props: {
    border: {
      type: Boolean,
      default: false
    },
    aspectRatio: {
      type: Number,
      default: 1.15
    },
    src: {
      type: [String, Array, Object],
      default: ""
    },
    not_in_stock: {
      type: Boolean,
      default: false
    },
    list: {
      type: Boolean,
    },
  },

  computed: {
    isString() {
      return typeof this.src === "string";
    },
    isArray() {
      return Array.isArray(this.src);
    },
    isObject() {
      return typeof this.src === "object";
    }
  }
};
</script>

<style lang="scss" scoped>
.product-image {
  position: relative;
  overflow: hidden;
  text-align: center;
  color: white;

  &.border {
    border: 1px solid #cccccc;
    border-radius: 4px;
  }

  .request-only {
    position: absolute;
    top: 6px;
    left: 8px;
    border-radius: 2px;
    border: 1px solid #fff;
    padding: 4px 8px 2px;
    background: #173169;
    font-size: 10px;
    line-height: 1.2;
    color: #fff;
  }
}

.image-default {
  background-image: url('../../../assets/preview.jpg');
  background-size: cover;
  background-position: center;
}

.image-container {
  background-image: url('../../../assets/image-loading.png');
  background-size: cover;
  background-position: center;
}

.fill {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 1s ease-in;
}

.fill[lazy=loaded] {
  opacity: 1;
}

.list {
  .request-only {
    top: 4px;
    left: 2px;
    white-space: nowrap;
    transform: scale(0.5);
    transform-origin: 0 0;
  }
}
</style>
